import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { createCenter } from '../../../services/supabaseService';

const AddCenterModal = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    address: '',
    city: '',
    country: 'India',
    pincode: '',
    ownerName: '',
    centerManagerName: '',
    inventoryType: 'coworking',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await createCenter({
        id: formData?.id,
        name: formData?.name,
        location: formData?.city,
        address: formData?.address,
        city: formData?.city,
        country: formData?.country,
        ownerName: formData?.ownerName,
        centerManagerName: formData?.centerManagerName,
        inventoryType: formData?.inventoryType,
        totalSqft: 0,
        totalSeats: 0,
        status: 'active',
      });
      onSuccess?.();
    } catch (err) {
      console.error('Error creating center:', err);
      setError(err?.message || 'Failed to create center');
    } finally {
      setLoading(false);
    }
  };

  const inventoryTypeOptions = [
    { value: 'coworking', label: 'Coworking' },
    { value: 'managed_office', label: 'Managed Office' },
    { value: 'mandated_property', label: 'Mandated Property' },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-900">Add New Center</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-3">
              <Icon name="AlertCircle" size={20} className="text-red-500" />
              <p className="text-red-700">{error}</p>
            </div>
          )}

          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900">Center Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Center ID *</label>
                <Input
                  type="text"
                  name="id"
                  value={formData?.id}
                  onChange={handleChange}
                  placeholder="CTR001"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Building/Coworking Name *</label>
                <Input
                  type="text"
                  name="name"
                  value={formData?.name}
                  onChange={handleChange}
                  placeholder="Mumbai Central Hub"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Address *</label>
                <Input
                  type="text"
                  name="address"
                  value={formData?.address}
                  onChange={handleChange}
                  placeholder="123 Linking Road, Bandra West"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">City *</label>
                <Input
                  type="text"
                  name="city"
                  value={formData?.city}
                  onChange={handleChange}
                  placeholder="Mumbai"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Pincode *</label>
                <Input
                  type="text"
                  name="pincode"
                  value={formData?.pincode}
                  onChange={handleChange}
                  placeholder="400050"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Country *</label>
                <Input
                  type="text"
                  name="country"
                  value={formData?.country}
                  onChange={handleChange}
                  placeholder="India"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Owner Name *</label>
                <Input
                  type="text"
                  name="ownerName"
                  value={formData?.ownerName}
                  onChange={handleChange}
                  placeholder="John Doe"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Center Manager Name *</label>
                <Input
                  type="text"
                  name="centerManagerName"
                  value={formData?.centerManagerName}
                  onChange={handleChange}
                  placeholder="Jane Smith"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Type of Inventory *</label>
                <Select
                  name="inventoryType"
                  value={formData?.inventoryType}
                  onChange={(value) => handleSelectChange('inventoryType', value)}
                >
                  {inventoryTypeOptions?.map((option) => (
                    <option key={option?.value} value={option?.value}>
                      {option?.label}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" loading={loading}>
              Add Center
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCenterModal;